import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';
import { Download, Award } from 'lucide-react';
import { downloadPdf } from '../../utils/downloadPdf';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PortalLicenses() {
  const { t } = useLanguage();
  const [licenses, setLicenses] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${API}/api/licenses`, { withCredentials: true }).then(r => setLicenses(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar type="portal" active="licenses" />
      <main data-testid="portal-licenses-page" style={{ flex: 1, background: 'var(--bg-portal)', padding: 32 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700, marginBottom: 24 }}>{t('portal.licenses')}</h1>
          <div style={{ background: 'white', border: '1px solid var(--border)' }}>
            {licenses.length === 0 ? (
              <div style={{ padding: 48, textAlign: 'center', color: 'var(--text-muted)' }}>{t('portal.no_licenses')}</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)' }}>
                      {[t('portal.product'), 'License Key', t('portal.status'), 'Expiry', 'Certificate'].map(h => (
                        <th key={h} style={{ padding: '12px 20px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {licenses.map((lic: any) => (
                      <tr key={lic._id} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '14px 20px', fontSize: 14, fontWeight: 500 }}>{lic.product}</td>
                        <td style={{ padding: '14px 20px', fontSize: 13, fontFamily: 'var(--font-mono)', color: 'var(--text-secondary)' }}>{lic.license_key || '-'}</td>
                        <td style={{ padding: '14px 20px' }}>
                          <span style={{ padding: '4px 10px', fontSize: 12, fontWeight: 600, background: lic.status === 'active' ? 'rgba(34,197,94,0.12)' : 'rgba(239,68,68,0.12)', color: lic.status === 'active' ? '#16A34A' : '#DC2626', textTransform: 'uppercase' }}>
                            {t(`status.${lic.status}`)}
                          </span>
                        </td>
                        <td style={{ padding: '14px 20px', fontSize: 13, color: 'var(--text-muted)' }}>{lic.expiry_date || '-'}</td>
                        <td style={{ padding: '14px 20px' }}>
                          <button onClick={() => downloadPdf(`/api/licenses/${lic._id}/certificate`, `certificate-${lic._id.slice(-8)}.pdf`)} data-testid={`certificate-${lic._id}`}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', fontSize: 11, fontWeight: 600, background: 'rgba(13,71,161,0.08)', color: 'var(--primary)', border: '1px solid rgba(13,71,161,0.2)', cursor: 'pointer' }}>
                            <Award size={12} /> Certificate
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
